{
  "2026": [
    {
      "data": "2026-04-20",
      "nome": "Ponto facultativo",
      "baseLegal": "Portaria MGI nº 11.460/2025"
    },
    {
      "data": "2026-06-05",
      "nome": "Ponto facultativo",
      "baseLegal": "Portaria MGI nº 11.460/2025"
    }
  ]
}
